import PropTypes from 'prop-types';
import { IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// An info icon that shows a short text when it is hovered, focused or tapped
const InfoTip = ({ text, label, color }) => {
  if (!text) return null;
  return (
    <Tooltip
      arrow
      placement="bottom"
      enterTouchDelay={0}
      leaveTouchDelay={12000}
      // the career window sits on layer 10000
      PopperProps={{ sx: { zIndex: 20000 } }}
      componentsProps={{
        tooltip: { sx: { maxWidth: 320, p: 1.5, bgcolor: '#12151c', textAlign: 'left' } },
        arrow: { sx: { color: '#12151c' } },
      }}
      title={<Typography component="p" sx={{ fontSize: '12.5px !important', lineHeight: '1.5 !important', fontWeight: 400, textAlign: 'left' }}>{text}</Typography>}
    >
      <IconButton aria-label={label} size="small" sx={{ ml: 0.5, p: 0.25, color: color || 'inherit', verticalAlign: 'middle' }}>
        <InfoOutlinedIcon sx={{ fontSize: '18px' }} />
      </IconButton>
    </Tooltip>
  );
};

InfoTip.propTypes = { text: PropTypes.string, label: PropTypes.string.isRequired, color: PropTypes.string };

export default InfoTip;
